
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('education')

export default {
  name: 'StreamListFirstTimeSelect',

  props: {
    availableStreamLists: {
      type: Array,
      default: () => [],
      required: true
    },

    attendeeId: {
      type: Number,
      default: 0,
      required: true
    },

    refreshTab: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      i18n: 'pages.education.courses-list.gu-stream-lists'
    }
  },

  computed: {
    ...mapState(['streamLists']),

    isStreamList() {
      return (
        this.availableStreamLists.length && Object.keys(this.streamLists).length
      )
    }
  },

  methods: {
    openUseDesk() {
      window.usedeskMessenger?.open('chat')
    }
  }
}
